import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SummaryApi from "../common/index"; // Assuming you already have your API configuration here

import "@react-pdf-viewer/core/lib/styles/index.css";
import newsdetails from "../Assets/Newsdetails.png";
import { BiSolidFilePdf } from "react-icons/bi";

const NewsDetails = () => {
  const location = useLocation();
  const { news_id } = location.state; // Access newsId from navigation state

  // Log the received news_id to ensure it's correct
  console.log("Received news_id:", news_id);

  // State to store the news details
  const [newsItem, setNewsItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewsDetails = async () => {
      try {
        // Fetch all news data from the API
        const response = await fetch(SummaryApi.getNews.url, {
          method: SummaryApi.getNews.method,
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          if (response.status === 404) {
            setError("News not found");
          } else {
            setError("Failed to fetch news details");
          }
          return;
        }

        const data = await response.json();

        // Log the API response to check the data
        console.log("API Response Data:", data);

        // Assuming the API response structure has 'data' with a list of news items
        if (data && data.data) {
          // Find the news item by news_id from the API data
          const foundNewsItem = data.data.find(
            (item) => item.news_id === String(news_id)
          );

          if (foundNewsItem) {
            setNewsItem(foundNewsItem); // Set the found news item
          } else {
            setError("News not found");
          }
        }
      } catch (error) {
        setError("Error fetching news details");
      } finally {
        setLoading(false); // Set loading to false once the fetch is complete
      }
    };

    fetchNewsDetails(); // Fetch news details on mount

    // Scroll to top when the page is opened
    window.scrollTo(0, 0);
  }, [news_id]); // Run the effect again if newsId changes

  // Render loading state
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-gray-500">Loading...</div>
      </div>
    );
  }

  // Render error state
  if (error) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-red-500">{error}</div>
      </div>
    );
  }

  // Render the news details if they exist
  if (!newsItem) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-xl text-gray-500">News not found</div>
      </div>
    );
  }

  // Function to handle PDF opening in a new tab
  const openPdfInNewTab = (pdfPath) => {
    const pdfUrl = `${SummaryApi.getNewsPdf.url}${pdfPath}`;
    window.open(pdfUrl, "_blank"); // Open PDF in a new tab
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h1 className="text-4xl font-semibold text-center text-gray-900 mb-6 text-[#33095F]">
        News
      </h1>
      <hr className="text-[#33095F]" />
      <div>
        <img src={newsdetails} alt="News Details" />
      </div>
      <div className="max-w-8xl mx-auto p-6 mt-1 shadow-lg bg-[#947fab]">
        <h1 className="text-[#dff628] text-3xl font-bold">Latest News !</h1>
        <p className="text-l text-gray-800 mb-4 text-white">
          {newsItem.message}
        </p>
      </div>

      {/* Conditionally render the "View Pdf" section if pdf_path exists */}
      {newsItem.pdf_path && (
        <p
          className="bg-[#f16565] p-2 flex justify-end pr-[3%] text-white cursor-pointer"
          // onClick={openPdfInNewTab()} 
          onClick={() => openPdfInNewTab(newsItem.pdf_path)}
        >
          <span className="text-xl text-red">
            <BiSolidFilePdf />
          </span>
          View Pdf
        </p>
      )}
    </div>
  );
};

export default NewsDetails;
